//意大利
export default {
    login1: 'Hai già un account? ',
    login2: 'Vai al login',
    login3: 'Reimpostare la password? ',
    login4: 'Inizia a usare 51shopy',
    login5: 'Hai dimenticato la password?',
    login6: 'Registrati ora',
    login7: 'E-mail',
    login8: 'Codice di verifica',
    login9: 'Inserisci codice di verifica',
    login10: "parola d'ordine",
    login11: 'Conferma password',
    login12: 'Inserisci nuovamente la password',
    login13: 'Registrati',
    login14: 'Passo successivo',
    login15: 'Invia',
    login16: 'Invia codice di verifica',
    login17: "Inserisci l'indirizzo email corretto e il codice di verifica!'",
    login18: 'Le password inserite due volte non corrispondono!',
    login19: 'Il codice di verifica è stato inviato',
    login20: "L'indirizzo email non può essere vuoto",
    login21: "Il formato dell'email non è corretto",
    login22: 'Il codice di verifica non può essere vuoto',
    login23: 'La lunghezza del codice di verifica è di 4 caratteri',
    login24: 'La password non può essere vuota',
    login25: 'La lunghezza della password non può essere inferiore a 6 caratteri',
    login26: 'Password modificata con successo! ',
    login27: 'Registrazione avvenuta con successo! ',
    login28: 'Accesso riuscito',
    login29: `Il nome dell'account non può essere vuoto`,
    login30: 'Accedi al tuo account qui sotto per iniziare',
    login31: 'Conto',
    login32: 'Clicca per effettuare il login',
    login33: "Acquista prodotti di qualità e goditi i bonus",
    login34: "Registrati per godere di un regalo meraviglioso",
    login35: "Accedi",
    login36: "Registrati",

    home1: 'Popolare',
    home2: 'Sei sicuro di voler effettuare il logout? ',
    home3: 'Richiesta',
    home4: 'OK',
    home5: 'Annulla',
    home6: 'Fan',
    home7: 'Segui',
    home8: 'Centro personale',
    home9: "L'ho comprato",
    home10: "L'ho venduto",
    home11: 'Il mio portafoglio',
    home12: 'Esci',
    home13: 'Totale',
    home14: 'elementi',
    home15: "Pagamento",
    home16: 'Prezzo accessibile',
    home17: 'Logistica veloce',
    home18: 'Garanzia di qualità',
    home19: 'Chi siamo',
    home20: 'Centro assistenza',
    home21: 'Servizio post-vendita',
    home22: 'Consegna e accettazione',
    home23: 'Cooperazione commerciale',
    home24: 'Raccomandazioni di ricerca',
    home25: 'Link amichevoli',
    home26: 'Segui',
    home27: 'Già preoccupato',
    home28: 'Acquista ora',
    home29: 'Agg. car.',
    home30: 'Raccolta riuscita! ',
    home31: 'Annullamento della raccolta eseguito con successo! ',
    home32: 'Sei sicuro di voler smettere di seguire?',
    home33: 'Annullato con successo! ',
    home34: 'Segui il successo! ',
    home35: 'Il contenuto non può essere vuoto',
    home36: 'Commento riuscito!',
    home37: 'Recensioni di prodotti',
    home38: 'Valuta ora',
    home39: 'Valutazione',
    home40: 'Storia',
    home41: 'Annullamento del follow effettuato con successo! ',
    home42: 'Questo tizio è molto misterioso e non ha una biografia. ',
    home43: 'casa',
    number1: 'Il mio account',
    number2: 'Centro Personale',
    number3: 'Portafoglio',
    number4: 'I miei preferiti',
    number5: 'La mia attenzione',
    number6: 'I miei fan',
    number7: 'Cronologia di navigazione',
    number8: 'Gestione delle transazioni',
    number9: 'Ho postato',
    number10: 'Ho comprato',
    number11: "L'ho venduto",
    number12: 'Carrello',
    number13: 'Homepage personale',
    number14: 'Servizio Clienti',
    number15: 'Impostazioni',
    number16: 'Nuovo indirizzo',
    number17: 'Modifica indirizzo',
    number18: 'Possono essere caricati solo file immagine!',
    number19: 'La dimensione del file non può superare i 10 MB!',
    number20: 'Immagine caricata con successo',
    number21: 'Equilibrio',
    number22: 'Raccogli oggetti',
    number23: 'Informazioni personali',
    number24: 'Modifica',
    number25: 'Invia',
    number26: 'Soprannome',
    number27: 'Profilo personale',
    number28: 'indirizzo di consegna',
    number29: 'Aggiungi',
    number30: 'Predef.',
    number31: 'Non pagato',
    number32: 'In attesa di consegna',
    number33: 'Completato',
    number34: 'Annullato',
    number35: 'In attesa di revisione',
    number36: 'Superato',
    number37: 'Rifiutato',
    number38: 'Ordine completato',
    number39: 'Pagamento ordine effettuato con successo!',
    number40: 'Ordine annullato con successo! ',
    number41: 'Prelievo effettuato con successo! ',
    number42: 'Ricarica',
    number43: 'Ritirarsi',
    number44: 'Storia dei consumi',
    number45: 'N. ordine',
    number46: 'nome del pagamento',
    number47: 'Tutti',
    number48: 'Domanda',
    number49: 'N. ordine',
    number50: 'nome del pagamento',
    number51: 'moneta 51',
    number52: "Stato dell'ordine",
    number53: "Ora di creazione dell'ordine",
    number54: 'Orario di aggiornamento ordine',
    number55: 'Operazione',
    number56: 'Pagato',
    number57: 'Annulla ordine',
    number58: 'Dettagli',
    number59: 'Numero',
    number60: 'spedito',
    number61: 'in attesa',
    number62: 'Registro dei prelievi',
    number63: 'ID utente',
    number64: 'Importo del prelievo',
    number65: 'Stato',
    number66: 'Ora di creazione',
    number67: 'Preleva dal portafoglio',
    number68: 'Ritirarsi',
    number69: 'Dettagli ordine portafoglio',
    number70: 'Tutti gli ordini',
    number71: 'In attesa di pagamento',
    number72: 'In attesa di consegna',
    number73: 'Completato',
    number74: 'Annullato',
    number75: 'Pagato',
    number76: 'Tutte le spedizioni',
    number77: 'N. ordine logistico',
    number78: "Spedizione avvenuta con successo!",
    number79: "L'ho venduto",
    number80: "Ancora nessun dato sull'ordine",
    number81: 'N. ordine',
    number82: 'Tempo di ordinazione',
    number83: "Persona incaricata dell'ordine",
    number84: 'Cambia ora',
    number85: 'Dettagli',
    number86: 'Totale',
    number87: 'spedito',
    number88: 'Dettagli',
    number89: "Inserisci il numero dell'ordine logistico",
    number90: 'N. ordine logistico',
    number91: "Inserisci il numero dell'ordine logistico",
    number92: 'Annullamento eseguito con successo!',
    number93: 'Riuscito!',
    number94: 'Ordine in ritardo consegna riuscita!',
    number95: 'Ho comprato',
    number96: 'Paga adesso',
    number97: 'Conferma ricezione',
    number98: 'Consegna in ritardo',
    number99: 'Annulla ordine',
    number100: 'Utente venditore',
    number101: 'La mia collezione',
    number102: 'I miei fan',
    number103: 'Il mio seguito',
    number104: 'nome del pagamento',
    number105: 'moneta 51',
    number106: "Stato dell'ordine",
    number107: 'Tempo di pagamento',
    number108: 'Pagato',
    number109: 'Pagamento ordine effettuato con successo! ',
    number110: 'Tutti i prodotti',
    number111: 'Sei sicuro di voler eliminare il prodotto?',
    number112: 'Eliminato con successo! ',
    number113: 'Annullato con successo! ',
    number114: 'Sei sicuro di voler mettere il prodotto sullo scaffale?',
    number115: 'Sei sicuro di voler rimuovere il prodotto?',
    number116: 'Riuscito! ',
    number117: 'Sullo scaffale',
    number118: "pronto all'uso",
    number119: 'Elimina',
    number120: 'Visualizza dettagli',
    cart1: 'Informazioni sul prodotto',
    cart2: 'prezzo unitario',
    cart3: 'Quantità',
    cart4: 'Subtotale',
    cart5: 'operazione',
    cart6: 'prezzo unitario',
    cart7: 'Sei sicuro di voler eliminare?',
    cart8: 'Conferma',
    cart9: 'Annulla',
    cart10: 'elimina',
    cart11: "L'elenco del carrello è vuoto",
    cart12: 'articoli, totale articoli',
    cart13: 'Totale',
    cart14: 'Pagamento',
    cart15: 'Aggiungi indirizzo',

    cart16: 'Devi compilare uno dei campi Telegram e WatchApp',
    cart17: 'Configurazione delle informazioni utente riuscita!',
    cart18: "Seleziona o compila l'indirizzo di consegna!'",
    cart19: 'Ordine creato con successo! ',
    cart20: 'indirizzo di consegna',
    cart21: "È necessario aggiungere un indirizzo di consegna prima di inviare l'ordine. ",
    cart22: 'Destinatario',
    cart23: 'Informazioni di contatto',
    cart24: 'indirizzo di consegna',
    cart25: 'Cambia indirizzo',
    cart26: 'Aggiungi indirizzo',
    cart27: 'Informazioni sul prodotto',
    cart28: 'Prezzo unitario',
    cart29: 'Quantità',
    cart30: 'Pagamento effettivo',
    cart31: 'Prezzo totale',
    cart32: 'Dettagli importo',
    cart33: 'Importo totale da pagare',
    cart34: 'Conf. ordine',
    cart35: 'Cambia indirizzo di consegna',
    cart36: 'Annulla',
    cart37: 'OK',
    cart38: 'Informazioni utente',
    cart39: 'Invia',
    cart40: 'Il cognome non può essere vuoto',
    cart41: 'Il nome non può essere vuoto',
    cart42: 'Il numero di cellulare non può essere vuoto',
    cart43: 'Il paese non può essere vuoto',
    cart44: 'La provincia/comune/distretto non può essere vuota',
    cart45: 'La città non può essere vuota',
    cart46: "L'indirizzo dettagliato non può essere vuoto",
    cart47: 'Il codice postale non può essere vuoto',
    cart48: 'Indirizzo modificato con successo! ',
    cart49: 'Indirizzo aggiunto con successo! ',
    cart50: 'cognome',
    cart51: 'nome',
    cart52: 'Paese',
    cart53: 'Provincia/Comune/Regione',
    cart54: 'città',
    cart55: 'Indirizzo dettagliato',
    cart56: 'Codice postale',
    cart57: 'Numero di telefono di contatto',
    cart58: 'È predefinito',
    cart59: 'casa',
    cart60: 'Servizio Clienti',
    cart61: 'Pubblica',
    cart62: 'Il mio',
    cart63: 'Carrello',
    cart64: 'Tempo di spedizione',
    cart65: 'Tempo di pagamento',
    cart66: 'Informazioni sulla consegna',
    cart67: 'Pagamento effettivo',
    cart68: 'Invia a',
    cart69: 'Prodotti',
    cart70: 'Puoi richiedere la fattura',
    cart71: "Informazioni sull'ordine",
    cart72: 'Commerciante',
    cart73: 'Invio riuscito! ',
    cart74: 'Copia riuscita',
    cart75: 'Copia fallita',
    cart76: 'proporzione',
    cart77: 'Limite di credito',
    cart78: 'Trasferisci',
    cart79: 'Importo ricarica',
    cart80: 'Ricarica',
    cart81: 'Classificazione',
    setup1: 'Informazioni personali',
    setup2: 'Il mio indirizzo di consegna',
    setup3: 'Il mio profilo',
    setup4: 'Account e sicurezza',
    setup5: 'Privacy',
    setup6: 'Generale',
    setup7: 'Aiuto e feedback',
    setup8: 'Chi siamo',
    setup9: 'Esci',
    setup10: 'Messaggio della stazione',
    setup11: 'Ancora nessun dato',
    setup12: 'Agg. car. successo!',
    setup13: 'Agg. car. riuscito!',

    setup14: 'Modifica prodotto',
    setup15: 'Rilascio del prodotto',
    setup16: 'Immagine di copertina del prodotto',
    setup17: 'Categoria prodotto',
    setup18: 'Nome prodotto',
    setup19: 'Prezzo del prodotto (CNY)',
    setup20: 'Descrizione del prodotto',
    setup21: 'Immagini del prodotto ( Max 10 immagini)',
    setup22: 'Reimposta',
    setup23: 'Prodotto creato con successo! ',

    setup24: 'Scorte di prodotto insufficienti! ',
    setup25: 'Metodo di pagamento',
    setup26: '51coin',
    setup27: 'trasferimento',
    setup28: 'Link del prodotto o link nome/articolo',
    setup29: "L'utente non è un venditore e non può pubblicare prodotti!",
    setup30: 'Operazione non umana rilevata! ',
    setup31: 'Inventario prodotti',
    setup32: 'Viste',
    setup33: 'Ordine inviato con successo! ',
    setup34: 'Visualizza ordine',
    setup35: 'Inventario prodotti',
    setup36: 'La categoria del prodotto non può essere vuota',
    setup37: 'Il nome del prodotto non può essere vuoto',
    setup38: 'La descrizione del prodotto non può essere vuota',
    setup39: "L'inventario del prodotto non può essere vuoto",
    setup40: 'Il prezzo del prodotto non può essere vuoto',
    setup41: "L'immagine di copertina non può essere vuota",
    setup42: "L'immagine del prodotto non può essere vuota",
    setup43: 'Il trasferimento è stato effettuato ed è in attesa di conferma',
    setup44: 'Seleziona il metodo di trasferimento!',
    setup45: 'Tempo di completamento',
    setup46: 'Moneta 51',
    setup47: 'Pag. bonifico',
    setup48: 'Metodo di trasferimento',
    setup49: "Dettagli del prodotto",
    setup50: "Acquirente",
    setup51: "Il costo di spedizione del prodotto è",
    setup52: "Spese di spedizione",
    setup53: "Quantità di vendita",
    setup54: "Quantità minima di acquisto",
    setup55: "Nuovo indirizzo ",
    setup56: "Account ricevuto",
    setup57: "Informazioni di contatto del beneficiario",
    setup58: "Informazioni di contatto del commerciante",
    setup59: "Informazioni di contatto dell'acquirente",
    setup60: "Copia",
    setup61: "Popolare",
    setup62: "Compila almeno un campo",
    setup63: "Contattaci",
    setup64: "Stima della spedizione",
    setup65: "Iscriviti a noi",
    setup66: "Cooperazione tra celebrità di Internet all'estero",
    setup67: "Problemi di pagamento e post-vendita",
    setup68: "Dividendivi dell'utente",

    setup69: "Tipo di valuta",
    setup70: "Tasso di cambio",
    setup71: "Commissione di gestione",
    setup72: "Ricevuta effettiva",
    setup73: "Importo minimo di prelievo",
    setup74: "Valuta",
    setup75: "Commissione di gestione",
    setup76: "Ricevuta effettiva",

    setup78: "Codice invito",
    setup79: "Inserisci il codice di invito",
    setup80: "Il prefisso telefonico mobile non può essere vuoto",
    setup81: "Prefisso telefonico",
    setup82: "Annulla tempo",
    setup83: "Dettagli prelievo",
    setup84: "Dettagli dividendi",
    setup85: "È scaduto?",
    setup86: "Se usare",
    setup87: "Non scaduto",
    setup88: "Scaduto",
    setup89: "Non utilizzato",
    setup90: "Già utilizzato",
    setup91: "Parzialmente utilizzato",
    setup92: "sconto",
    setup93: "Rimborso usato",
    setup94: "Rimborso rimanente",
    setup95: "Se usare",
    setup96: "È scaduto?",
    setup97: "Tempo di scadenza",
    setup98: "Tempo di rimborso",
    setup99: "Condivisione Alleanza",
    setup100: "Annulla pagamento",
    setup101: "Chiudi l'interfaccia",
    setup102: "pagamento USDT",
    setup103: "Totale da pagare",
    setup104: "Importo della transazione dell'ordine",
    setup105: "Rete",
    setup106: "Paghi per la rete",
    setup107: "Pagamento riuscito",
    setup108: "Indirizzo del portafoglio del beneficiario",
    setup109: "Si prega di controllare attentamente che l'importo effettivo del pagamento sia coerente con l'importo trasferito. Se c'è un errore, ne sopporterai le conseguenze",
    setup110: "Tempo di scadenza",
    setup111: "In attesa del pagamento",
    setup112: "Pagamento riuscito",
    setup113: "Ordine scaduto",
    setup114: "Controlla le transazioni blockchain",
    setup115: "",
    setup116: "",
    setup117: "",
    setup118: "",
    setup119: "",

    setup130: "Chi siamo",
    setup131: "Relativo alla consegna",
    setup132: "Altro",
    setup133: "Politica di spedizione",
    setup134: "Orario di consegna/ritiro del pacco",
    setup135: "Termini di servizio",
    setup136: "Metodo di pagamento",
    setup137: "Politica di reso",
    setup138: "Informativa sulla privacy",
    setup139: "Space Network Technology Co., Ltd.",
    setup140: "Orario di lavoro:",
    setup141: "Persona di contatto:",
    setup142: "Email aziendale:",
    setup143: "Codice postale:",
    setup144: "Indirizzo: ",

    setup0140: "Da lunedì a venerdì (9:00-18:00)",
    setup0141: " Signor Liang",
    setup0143: "999077",
    setup0144: "Stanza 341, 3/F, Edificio industriale pubblico, 56 Hoi Yuen Road, Kwun Tong, Hong Kong",

    setup145: "Accordo di spedizione internazionale dei pacchi",
    setup146: "A causa della particolarità del trasporto internazionale, è necessario rispettare le norme sul trasporto internazionale di pacchi. Si prega di leggere attentamente e accettare i seguenti termini e condizioni.",
    setup147: "Standard di compensazione del pacchetto:",
    setup148: "Se i tuoi prodotti vengono persi, smarriti, danneggiati, ritardati o trattenuti dalla dogana durante il trasporto per motivi al di fuori del controllo di 51shopy, 51shopy non sarà responsabile per alcun risarcimento. Non ci assumiamo inoltre alcuna responsabilità per perdite di profitto indirette e non realizzate. Per i dettagli effettivi, fare riferimento a 'Assicurazione e risarcimento del pacco'.",
    setup149: "51shopy non è responsabile del risarcimento nei seguenti casi (per pacchi non assicurati):",
    setup150: "1. Non verrà fornito alcun risarcimento per la perdita di posta causata da forza maggiore come calamità naturali o motivi doganali;",
    setup151: "2. Se gli articoli spediti violano divieti o restrizioni, le autorità competenti li confischeranno o li tratteranno in conformità con le leggi e i regolamenti pertinenti senza indennizzo;",
    setup152: "3. Quando si invia un pacco, se il pacco è imballato in buone condizioni, non presenta segni di smontaggio e non ha perso peso, ma le parti interne sono mancanti o danneggiate, non verrà fornito alcun risarcimento;",
    setup153: "4. Se il tracciamento della posta mostra che il pacco non è stato consegnato normalmente e la società di logistica conferma che il pacco è stato confiscato dalla dogana, la richiesta della società di logistica prevarrà e non verrà fornito alcun risarcimento;",
    setup154: "5. Non verrà corrisposto alcun risarcimento se la posta viene persa o il contenuto risulta mancante per colpa del cliente o della posta stessa;",
    setup155: "6. Se il cliente non effettua una richiesta e non presenta un reclamo dalla data di recapito dell'e-mail alla scadenza del periodo di richiesta, non verrà fornito alcun risarcimento;",
    setup156: "7. Se la posta internazionale viene trattenuta, confiscata o distrutta dal paese di destinazione in conformità con le sue leggi nazionali, non verrà fornito alcun risarcimento.",
    setup157: "Oggetti proibiti",
    setup158: "Rispettare le normative del nostro Paese sugli articoli proibiti e soggetti a restrizioni:",
    setup159: "1. Rispettare l'annuncio dell'Ufficio postale di Stato, del Ministero della Pubblica Sicurezza e del Ministero della Sicurezza dello Stato in merito all'emanazione del 'Regolamento sulla gestione degli articoli proibiti'.",
    setup160: "2. Rispettare le disposizioni dell'Ordinanza n. 43 dell'Amministrazione generale delle dogane (Elenco degli articoli proibiti e soggetti a restrizioni per l'importazione e l'esportazione della Repubblica popolare cinese).",
    setup161: "Articoli che non possono essere spediti per posta",
    setup162: "1. Articoli la cui circolazione e il cui trasporto sono vietati dalle leggi nazionali.",
    setup163: "2. Merci pericolose esplosive, infiammabili, corrosive, radioattive o tossiche.",
    setup164: "3. Pubblicazioni, libri, materiali o articoli contenenti contenuti reazionari o osceni.",
    setup165: "4. Valute diverse.",
    setup166: "5. Elementi che violano la salute pubblica.",
    setup167: "6. Articoli deperibili.",
    setup168: "7. Animali vivi (tranne api, bachi da seta e sanguisughe, purché l'imballaggio garantisca la sicurezza dei lavoratori).",
    setup169: "8. Un imballaggio inadeguato può rappresentare un pericolo per i lavoratori o contaminare o danneggiare altri articoli imballati.",
    setup170: "9. Altri articoli non adatti alla spedizione.",
    setup171: "Articoli la cui consegna è vietata secondo la prassi postale",
    setup172: "1. Articoli la cui qualità o imballaggio può causare danni ai dipendenti delle poste o contaminare/danneggiare altri pacchi o attrezzature postali.",
    setup173: "2. Articoli con sigilli metallici o altri bordi taglienti che potrebbero interferire con l'elaborazione postale.",
    setup174: "3. Vari tipi di armi da fuoco, munizioni, materiali o contenitori esplosivi, infiammabili, corrosivi, radioattivi, veleni potenti, stupefacenti, prodotti biochimici e materiali infettivi.",
    setup175: "4. Qualsiasi pubblicazione, materiale di propaganda o materiale stampato che possa mettere a repentaglio la sicurezza e la stabilità sociale o contenere contenuti osceni.",
    setup176: "5. Vari elementi che possono mettere in pericolo la salute pubblica.",
    setup177: "6. Documenti o articoli che non sono accettati o autorizzati a circolare nel paese ricevente.",
    setup178: "Metodi di pagamento disponibili",
    setup179: "Il sito web supporta diversi metodi di pagamento, tra cui carte di credito/debito, WeChat, Alipay, ecc. Se hai bisogno di effettuare pagamenti frequenti o detrazioni dal deposito a garanzia, puoi anche utilizzare il saldo per pagare.",
    setup180: "- Se si verifica un rimborso per un ordine di acquisto con carta di credito/debito, verrà rimborsato sul conto originale; anche il rimborso per la ricarica del saldo verrà rimborsato sul conto originale",
    setup181: "- Se si verifica un rimborso per i pagamenti degli ordini effettuati tramite WeChat, Alipay, ecc., il rimborso verrà restituito al conto originale;",
    setup182: "- Se avviene un rimborso per il pagamento del saldo, verrà rimborsato sul saldo del conto;",
    setup183: "Informativa sulla privacy degli utenti di 51shopy",
    setup184: "La sicurezza delle tue informazioni personali è molto importante per noi e diamo valore alla tua fiducia. In nessun caso venderemo o divulgheremo le tue informazioni personali a terze parti. Proteggeremo la sicurezza e la privacy di qualsiasi informazione personale che ci fornirai e utilizzeremo le informazioni solo come descritto qui. Se hai domande, suggerimenti o commenti su questa Informativa sulla privacy, puoi contattarci in qualsiasi momento visitando il sistema di assistenza clienti online di 51shopy o l'account di servizio ufficiale di 51shopy.",
    setup185: "Questa politica non si applica ai servizi forniti da terze parti, né ai servizi per i quali abbiamo definito in modo indipendente le nostre politiche sulla privacy.",
    setup186: "Si prega di leggere e comprendere attentamente questa politica prima di utilizzare i servizi di 51shopy. Il tuo consenso a questa politica sulla privacy significa che hai compreso le funzioni fornite da questa applicazione e le informazioni personali necessarie richieste per eseguire le funzioni.",
    setup187: "I diritti di proprietà e operativi dei servizi utente registrati pertinenti appartengono a",
    setup188: "1. Quali informazioni personali raccogliamo?",
    setup189: "Puoi scegliere di usare o visitare il nostro sito web senza rivelare alcuna informazione personale e sulle transazioni che ti riguardano, ma devi registrarti per un account per provare il nostro servizio completo. Se ci fornisci le tue informazioni, accetti il ​​trasferimento e l'archiviazione delle informazioni sui nostri server.",
    setup190: "51shopy raccoglie le informazioni personali che fornisci quando utilizzi il sito web, che includono il tuo nome, le informazioni di contatto, l'indirizzo e-mail, il nome e la password dell'account 51shopy e altre informazioni necessarie per creare un account. Oltre alle informazioni personali che potremmo raccogliere ed elaborare durante la registrazione, raccogliamo, archiviamo ed elaboriamo anche le seguenti informazioni sui nostri utenti su 51shopy:",
    setup191: "1) Informazioni sull'acquisto",
    setup192: "2) Informazioni sull'account di servizio",
    setup193: "3) Informazioni di pagamento (orario del pagamento, importo del pagamento, canale di pagamento, ecc.)",
    setup194: "4) Cerca informazioni nella cronologia di navigazione (contenuto di ricerca, comportamento dei clic sui link, cronologia di navigazione, cronologia delle visualizzazioni dei clic, ecc.)",
    setup195: "5) Cookie e altre informazioni del computer",
    setup196: "Abbiamo stretto una partnership con Microsoft Clarity e Microsoft Advertising per catturare il modo in cui utilizzi e interagisci con il nostro sito Web tramite metriche comportamentali, mappe di calore e replay di sessione per migliorare e commercializzare i nostri prodotti/servizi. I dati sull'utilizzo del sito vengono catturati utilizzando cookie proprietari e di terze parti e altre tecnologie di tracciamento per determinare la popolarità di prodotti/servizi e attività online. Inoltre, utilizziamo queste informazioni per l'ottimizzazione del sito, per scopi di frode/sicurezza e per la pubblicità. Per ulteriori informazioni su come Microsoft raccoglie e utilizza i tuoi dati, visita",
    setup197: "Informativa sulla privacy di Microsoft",
    setup198: "2. Come utilizziamo le tue informazioni personali?",
    setup199: "Non venderemo né divulgheremo le informazioni personali di alcun utente e ci impegneremo a proteggere le tue informazioni e la tua privacy. Utilizzeremo le tue informazioni per fornirti servizi migliori, tra cui:",
    setup200: "1) Contattarti via e-mail e fornirti una serie di nostri servizi, tra cui servizi di consulenza, servizi di informazioni sugli ordini, servizi di informazioni sui pacchi, servizi post-vendita sui prodotti, ecc.",
    setup201: "2) Comunicarti le attività della piattaforma tramite e-mail, posta interna, ecc., inclusa la fornitura di coupon, sconti sulla spedizione e promozioni speciali, e la possibilità di utilizzare servizi di terze parti.",
    setup202: "3) Quando cerchi e navighi nei link dei nostri commercianti partner su 51shopy, il tuo ID utente 51shopy, i comportamenti operativi correlati e le informazioni (contenuto di ricerca, comportamento di clic sui link, cronologia di navigazione, cronologia di visualizzazione dei clic, ecc.) saranno forniti alla fonte del link del comportamento operativo, in modo che noi e i nostri commercianti partner possiamo lavorare insieme per fornirti servizi efficienti e di alta qualità. Puoi fare clic per visualizzare i commercianti partner di 51shopy (www.taobao.com, www.1688.com).",
    setup203: "In base alle leggi, ai regolamenti e agli standard nazionali, nelle seguenti circostanze, i partner non hanno bisogno della tua autorizzazione o del tuo consenso per utilizzare, trasferire o divulgare i tuoi dati personali:",
    setup204: "1) Secondo i requisiti obbligatori delle leggi, dei regolamenti, degli organi amministrativi e giudiziari e altri obblighi legali;",
    setup205: "2) Nella misura consentita dalle leggi e dai regolamenti, è necessario salvaguardare l'interesse pubblico, la sicurezza della proprietà e proteggere te o altri utenti di 51shopy, 51shopy, affiliati o partner di 51shopy da danni;",
    setup206: "3) Necessario per realizzare le funzioni principali dei nostri prodotti e/o servizi, o per fornire i servizi di cui hai bisogno;",
    setup207: "4) Elaborare le informazioni personali da te divulgate o altre informazioni personali che sono state divulgate legalmente (come le informazioni personali divulgate legalmente tramite notiziari legali, divulgazione di informazioni governative o altri canali) entro un ambito ragionevole;",
    setup208: "5) Gestire le controversie o le dispute tra te e gli altri in base alle tue esigenze;",
    setup209: "6) Rispettare gli accordi pertinenti sottoscritti con te (inclusi gli accordi elettronici online e le regole della piattaforma corrispondente) o altri documenti legali;",
    setup210: "7) Utilizzo basato su interessi pubblici sociali ed emergenze di sanità pubblica e nel rispetto delle leggi e dei regolamenti.",
    setup211: "Per gli scopi sopra indicati, hai anche il diritto di annullare questa notifica in qualsiasi momento. Puoi effettuare il login sul sito web 51shopy e impostarla tu stesso nella funzione personalizzata.",
    setup212: "Si prega di notare che non condivideremo i tuoi dati personali con nessun inserzionista a meno che non otteniamo il tuo consenso. Non richiederemo o rilasceremo informazioni personali a bambini o altre persone incapaci senza il consenso, la conoscenza e la presenza dei loro tutori.",
    setup213: "Con la presente riconosci, condividi e trasferisci informazioni personali de-identificate e garantisci che il destinatario dei dati non possa ripristinare e reidentificare il soggetto delle informazioni personali, il che non costituisce la condivisione, il trasferimento e la divulgazione pubblica di informazioni personali al mondo esterno. L'archiviazione e l'elaborazione di tali dati non richiedono notifica a te e il tuo consenso.",
    setup214: "Potremmo affidare a partner autorizzati l'elaborazione delle tue informazioni personali in modo che possano fornirti determinati servizi o svolgere determinate funzioni per nostro conto. Affideremo l'elaborazione delle tue informazioni solo per gli scopi legittimi, appropriati, necessari, specifici e chiari indicati nella presente politica e i partner autorizzati possono accedere solo alle informazioni necessarie per svolgere i propri compiti. 51shopy non fornirà il tuo indirizzo e-mail, il nome dell'account del sito Web 51shopy e la password, le informazioni di contatto e altre informazioni private ai nostri partner.",
    setup215: "3. Per quanto tempo conserveremo le tue informazioni?",
    setup216: "Una volta registrato con successo un account 51shopy, salveremo in modo permanente le tue informazioni personali. Se desideri annullare il tuo account o eliminare le tue informazioni personali, contatta il servizio clienti online.",
    setup217: "Ai sensi del GDPR, i titolari e i responsabili del trattamento dei dati sono tenuti a restituire o cancellare tutti i dati personali dopo la fine del servizio o la scadenza del contratto o dell'accordo, a meno che non vi sia un obbligo legale di conservare i dati.",
    setup218: "4. Come proteggiamo le tue informazioni personali",
    setup219: "Adotteremo tutte le misure ragionevoli e fattibili per proteggere le tue informazioni personali. Adotteremo tutte le misure ragionevoli e fattibili per garantire che non vengano raccolte informazioni personali irrilevanti.",
    setup220: "5. Aggiornamento della politica",
    setup221: "Per offrirti una migliore esperienza di prodotto e servizio, lavoriamo costantemente per migliorare i nostri prodotti, servizi e tecnologie. Quando cambiano nuovi servizi e processi aziendali, potremmo aggiornare la nostra politica sulla privacy per informarti di modifiche specifiche. Ti preghiamo di prestare attenzione a questa pagina in modo tempestivo e di seguire la politica più recente sulla pagina. Una volta pubblicata la politica più recente, sarà vincolante per te.",
    setup222: "6. Contattaci",
    setup223: "Se hai domande sulla presente informativa sulla privacy, contatta: ",
    setup224: "Si prega di leggere attentamente i Termini di servizio di 51shopy prima di registrarsi come utente e di assicurarsi di aver compreso appieno tali termini. Si prega di leggere attentamente e di scegliere se accettare o meno i Termini di servizio di 51shopy, in particolare i termini di esenzione o limitazione di responsabilità, legge applicabile e risoluzione delle controversie. A meno che non si accettino i Termini di servizio di 51shopy, non si ha il diritto di registrarsi, accedere o utilizzare i servizi di 51shopy. La registrazione, l'accesso e l'utilizzo saranno considerati come accettazione dei Termini di servizio di 51shopy e come accordo di essere vincolati dai Termini di servizio di 51shopy.",
    setup225: "I Termini di servizio di 51shopy stabiliscono i diritti e gli obblighi tuoi e di 51shopy in merito ai servizi di 51shopy (di seguito denominati 'Servizi'). I Termini di servizio di 51shopy possono essere aggiornati da 51shopy in qualsiasi momento. I Termini di servizio di 51shopy aggiornati sostituiranno i termini originali una volta pubblicati e pubblicizzati senza ulteriore preavviso. Puoi controllare l'ultima versione dei Termini di servizio di 51shopy sulla piattaforma 51shopy. Si consiglia inoltre di tenersi aggiornati sui Termini di servizio di 51shopy aggiornati per evitare inutili malintesi e controversie. Dopo che i Termini di servizio di 51shopy sono stati modificati, se non accetti i termini modificati, ti preghiamo di interrompere immediatamente l'utilizzo dei servizi forniti da 51shopy. Il tuo utilizzo continuato dei servizi forniti da 51shopy sarà considerato come accettazione dei Termini di servizio di 51shopy modificati.",
    setup226: "1. Ambito di applicazione delle presenti Condizioni di servizio",
    setup227: "I diritti di proprietà e operativi dei servizi utente registrati pertinenti appartengono a . I servizi forniti devono essere implementati in conformità con le regole del servizio, i termini e le specifiche operative da essa emanate, il che significa anche che gli utenti pertinenti hanno raggiunto un accordo con 51shopy e accettato tutti i suoi termini di servizio.",
    setup228: "2. Raccolta e utilizzo delle informazioni",
    setup229: "Quando utilizzi i servizi di 51shopy, potremmo dover raccogliere e utilizzare i seguenti due tipi di informazioni personali:",
    setup230: "1. Per fornirti le funzioni di base dei nostri servizi, devi autorizzarci a raccogliere e utilizzare le informazioni necessarie. Se rifiuti di fornire le informazioni corrispondenti, non sarai in grado di registrarti, accedere o utilizzare i nostri servizi normalmente;",
    setup231: "2. Per fornirti funzionalità aggiuntive dei nostri servizi, puoi scegliere di accettare o meno le informazioni che raccogliamo e utilizziamo. Se rifiuti di fornirle, non sarai in grado di utilizzare le funzionalità aggiuntive pertinenti o di ottenere gli effetti funzionali che intendiamo ottenere, e ciò non influirà sul tuo utilizzo delle nostre funzioni di base.",
    setup232: "Proteggiamo il tuo diritto di sapere e il tuo diritto di scegliere durante il processo di installazione o utilizzo in conformità con la legge. Quando utilizzi i servizi 51shopy, i servizi che coinvolgono funzioni fornite sul tuo dispositivo richiedono il tuo previo consenso. Dopo la tua conferma, 51shopy ha il diritto di abilitare le funzioni ausiliarie necessarie come la raccolta della posizione geografica, la lettura della rubrica, l'utilizzo della fotocamera e l'abilitazione dei servizi di registrazione.",
    setup233: "Le informazioni raccolte e utilizzate includono, ma non sono limitate a, il nome dell'utente, le informazioni di contatto e altre informazioni di base. L'utente accetta che l'uso di queste informazioni sia soggetto alle disposizioni dell'Articolo 3 'Protezione delle informazioni dell'utente.",
    setup234: "3. Protezione delle informazioni utente",
    setup235: "Non divulgheremo o riveleremo le tue informazioni personali a terzi a meno che:",
    setup236: "1. Condivisione necessaria per adempiere agli obblighi di legge;",
    setup237: "2. Condivisione con il tuo consenso;",
    setup238: "4. Diritti e obblighi dell'utente",
    setup239: "1. Hai il diritto di accedere al sito web 51shopy per rivedere, correggere e integrare le tue informazioni personali.",
    setup240: "2. Hai il diritto di contattare il servizio clienti online per annullare il tuo account. Dopo aver annullato il tuo account, interromperemo la fornitura di servizi e cancelleremo o renderemo anonime le tue informazioni personali in conformità con i requisiti delle leggi pertinenti.",
    setup241: "3. In alcune funzioni aziendali, potremmo prendere decisioni basate esclusivamente su meccanismi decisionali automatizzati non umani, inclusi algoritmi. Se queste decisioni incidono sui tuoi diritti legali, puoi contattarci tramite il servizio clienti.",
    setup242: "4. Tutte le informazioni fornite a 51shopy devono essere vere, accurate e non fuorvianti.",
    setup243: "L'utente riconosce e accetta di essere tenuto a mantenere l'autenticità e la validità delle informazioni fornite.",
    setup244: "5. Non puoi utilizzare il tuo account registrato o i servizi 51shopy per creare, caricare, copiare, pubblicare o diffondere contenuti che interferiscono con il normale funzionamento di 51shopy o che violano i legittimi diritti e interessi di altri utenti o di terze parti.",
    setup245: "6. Non puoi copiare, plagiare, vendere, rivendere o utilizzare per altri scopi commerciali alcuna parte del servizio 51shopy o il contenuto utilizzato o ottenuto tramite il servizio 51shopy.",
    setup246: "7. Sarai il solo responsabile dell'autenticità, legalità, accuratezza e validità di qualsiasi informazione trasmessa tramite il tuo account 51shopy o i servizi 51shopy. Qualsiasi responsabilità legale relativa a qualsiasi informazione trasmessa sarà a tuo carico e non ha nulla a che fare con 51shopy. Dovrai risarcire qualsiasi perdita causata a 51shopy o a terzi, e 51shopy si riserva il diritto di ritenere responsabili gli utenti interessati.",
    setup247: "8. Sarai pienamente responsabile delle conseguenze di tutte le azioni intraprese tramite il tuo account (incluse, a titolo esemplificativo ma non esaustivo, la firma di vari accordi online, la pubblicazione di informazioni, l'acquisto di beni e servizi e la divulgazione di informazioni).",
    setup248: "5. Memorizzazione delle informazioni",
    setup249: "51shopy non ha limiti massimi per la quantità di informazioni trasmesse. Abbiamo adottato misure di sicurezza ragionevoli e fattibili che soddisfano gli standard del settore per proteggere le tue informazioni e impedire che le informazioni personali vengano consultate, divulgate, utilizzate, modificate, danneggiate o perse senza autorizzazione. Ti preghiamo inoltre di proteggere adeguatamente le tue informazioni personali e di fornirle ad altri solo quando necessario. Non fidarti di altri strumenti di trading per evitare furti di informazioni o persino frodi online.",
    setup250: "6. Esclusione di responsabilità",
    setup251: "1.51shopy farà del suo meglio per ripristinare la situazione reale delle informazioni sul prodotto fornite, ma a causa dell'influenza di vari fattori come l'ambiente circostante, l'angolazione di ripresa, le differenze delle apparecchiature, ecc. durante il processo di ripresa del prodotto, non possiamo garantire che il prodotto sia esattamente uguale a quello reale.",
    setup252: "2.51shopy acquista prodotti designati in base alla piattaforma specificata dall'utente. Se la piattaforma specificata è esaurita, il prezzo cambia, la consegna è ritardata, il prodotto effettivo non corrisponde alle informazioni sul prodotto sul sito Web, il prodotto è anomalo o altri fattori di forza maggiore portano all'impossibilità di acquistare normalmente, ti contatteremo in tempo. Pertanto, 51shopy non si assume alcuna responsabilità per le perdite causate a te.",
    setup253: "3. Se i prodotti acquistati da 51shopy comportano problemi post-vendita (ad esempio esaurimento scorte, danni, difetti, ecc.), li gestiremo per te in modo tempestivo.",
    setup254: "4. 51shopy non si assume alcuna responsabilità per eventuali perdite o conseguenze causate dalla tua divulgazione proattiva del tuo account 51shopy o da attacchi, frodi, ecc. da parte di altri. Dovresti cercare un risarcimento dal trasgressore tramite rimedi legali o altri mezzi.",
    setup255: "7. Comportamento proibito",
    setup256: "Non puoi utilizzare i servizi 51shopy per le seguenti attività:",
    setup257: "(1) Violazione di qualsiasi legge, statuto, decreto o regolamento.",
    setup258: "(2) Sono coinvolte le seguenti transazioni:",
    setup259: "(a) stupefacenti, steroidi, alcuni farmaci controllati o altri prodotti che possono mettere a repentaglio la sicurezza dei consumatori;",
    setup260: "(b) strumenti per la droga;",
    setup261: "(c) Sigarette;",
    setup262: "(d) cannabis o altre piante psicoattive non autorizzate;",
    setup263: "(e) nutrizione, vitamine, integratori, erbe e prodotti naturali per la salute in abbonamento;",
    setup264: "(f) qualsiasi materiale che istighi, induca, assista o indirizzi altri a impegnarsi in attività illegali;",
    setup265: "(g) oggetti rubati, compresi oggetti digitali e virtuali;",
    setup266: "(h) materiali che incitano all'odio, alla violenza, al fanatismo razziale o ad altre forme di intolleranza o che sfruttano l'attività criminale;",
    setup267: "(i) considerato osceno;",
    setup268: "(j) qualsiasi materiale che violi o infranga il copyright, il marchio commerciale, la pubblicità o la privacy o qualsiasi altro diritto di proprietà ai sensi delle leggi di qualsiasi giurisdizione;",
    setup269: "(k) determinati materiali o servizi pornografici;",
    setup270: "(l) munizioni, armi o determinate parti o accessori di armi, o",
    setup271: "(m) Alcune armi o coltelli regolamentati dalla legge applicabile.",
    setup272: "（3）Relativo alle seguenti transazioni:",
    setup273: "(a) Divulgazione di informazioni personali di terzi in violazione delle leggi pertinenti;",
    setup274: "(b) supporta schemi piramidali, schemi Ponzi, schemi a matrice, altri schemi per arricchirsi rapidamente o determinati schemi downline multilivello;",
    setup275: "(c) transazioni relative all'acquisto di rendite o contratti di lotteria, sistemi di acquisto di depositi prepagati, servizi bancari offshore o transazioni per finanziare o rifinanziare debiti di carte di credito;",
    setup276: "(d) vendere qualcosa prima che il venditore ne abbia il controllo o il possesso;",
    setup277: "(e) i processori di pagamento raccolgono i pagamenti per conto dei commercianti;",
    setup278: "(f) in relazione alla vendita di assegni di viaggio o di vaglia postali;",
    setup279: "(g) che comportano operazioni di cambio valuta o di incasso assegni;",
    setup280: "(h) comporta determinati servizi di riparazione del credito o di liquidazione del debito, transazioni con carta di credito o attività assicurative, o",
    setup281: "(i) comporta l'effettuazione o la ricezione di pagamenti correlati a corruzione o tangenti.",
    setup282: "(4) Che riguarda la vendita di prodotti o servizi che le agenzie governative hanno determinato possano essere fraudolenti.",
    setup283: "Ti assumi la responsabilità legale per l'utilizzo dei servizi di 51shopy, inclusi, a titolo esemplificativo ma non esaustivo, i risarcimenti per le perdite subite dalla parte lesa e, dopo che 51shopy si è inizialmente assunta la responsabilità legale, come sanzioni amministrative o risarcimenti per violazione causati dal comportamento dell'utente, dovrai pagare a 51shopy un importo equivalente a titolo di risarcimento e altre perdite subite da 51shopy di conseguenza.",
    setup284: "8. Responsabilità di risarcimento",
    setup285: "1. Se le tue azioni causano perdite a 51shopy e/o alle sue affiliate (incluse perdite economiche dirette, perdita di avviamento e perdite economiche indirette quali indennizzi, transazioni, parcelle degli avvocati, assicurazione di conservazione, parcelle per contenziosi, ecc.), dovrai risarcire 51shopy e/o le sue affiliate per tutte le perdite.",
    setup286: "2. Se le tue azioni causano una causa intentata da terzi contro 51shopy e/o i suoi affiliati (inclusi, ma non limitati a, venditori su Taobao, 1688 e altre piattaforme), 51shopy e/o i suoi affiliati possono recuperare tutte le perdite da te dopo aver assunto obblighi quali un risarcimento monetario nei confronti della terza parte.",
    setup287: "9. Legge applicabile e giurisdizione",
    setup288: "1. Il presente Contratto di servizio e qualsiasi altro accordo separato mediante il quale ti forniamo servizi saranno regolati e interpretati in conformità con le leggi di Hong Kong.",
    setup289: "2. Qualsiasi controversia derivante dal tuo utilizzo dei servizi 51shopy e controversie relative ai servizi 51shopy saranno risolte tramite negoziazione tra 51shopy e te. Se la negoziazione fallisce, entrambe le parti possono presentare una causa presso il tribunale con giurisdizione sul luogo in cui è stato firmato questo accordo.",
    setup290: "Di seguito è riportato il programma di uscita dal magazzino (inviato al magazzino del fornitore di servizi logistici) / programma di ritiro del fornitore di servizi logistici, solo a scopo di riferimento (il programma effettivo è soggetto agli accordi di ciascun fornitore di servizi logistici):",
    setup291: "Orario di consegna/ritiro del pacco:",
    setup292: "Quando lo stato del pacco nel magazzino 51shopy è 'Imballato', la società di logistica e magazzino organizzerà la consegna/il ritiro entro un orario stabilito (la società di logistica è chiusa nei fine settimana e nei giorni festivi e il ritiro verrà posticipato).",
    setup293: "Percorso",
    setup294: "Orario di invio/ritiro (ora di Pechino)",
    setup295: "GD-EMS",
    setup296: "Ritiro dal lunedì alla domenica",
    setup297: "GD-EUB",
    setup298: "Ritiro dal lunedì alla domenica",
    setup299: "GD-E-EMS",
    setup300: "Ritiro dal lunedì alla domenica",
    setup301: "EUB-T",
    setup302: "Ritiro dal lunedì alla domenica",
    setup303: "DHL Express",
    setup304: "Ritiro dal lunedì al sabato",
    setup305: "DHL Heavy Cargo Standard Express",
    setup306: "Ritiro dal lunedì al sabato",
    setup307: "Linea speciale DHL europea",
    setup308: "Spedizione dal lunedì alla domenica (consegna al magazzino del fornitore logistico)",
    setup309: "Linea americana (piccola)",
    setup310: "Spedizione dal lunedì alla domenica (consegna al magazzino del fornitore logistico)",
    setup311: "Linea britannica (piccola)",
    setup312: "Spedizione dal lunedì alla domenica (consegna al magazzino del fornitore logistico)",
    setup313: "Corea EMS",
    setup314: "Spedizione dal nostro magazzino ogni giorno",
    setup315: "Pacchetto postale PDB",
    setup316: "Haibao",
    setup317: "Ferrovie europee",
    setup318: "United Parcel Service Hong Kong Limited",
    setup319: "Linea dedicata Aramex",
    setup320: "SAL",
    setup331: "SME",
    setup332: "PD-EUB",
    setup333: "Linea britannica",
    setup334: "NH-EMS",
    setup335: "Linea duty-free europea",
    setup336: "Linea americana",
    setup337: "YTO Express",
    setup338: "SF Express",
    setup339: "51shopy è una piattaforma che fornisce servizi di acquisto e spedizione di prodotti cinesi, offrendo agli utenti servizi di ricerca di informazioni sui prodotti, acquisto e spedizione. Durante questo periodo, 51shopy fornisce servizi di base di ispezione dei prodotti, conferma delle comunicazioni con i commercianti e servizi post-vendita per proteggere i tuoi diritti e interessi legali e garantire la tua esperienza di acquisto.",
    setup340: "Se ritieni che i prodotti acquistati siano contraffatti o di qualità inferiore, contatta il nostro servizio clienti o invia un'e-mail a",
    setup341: "1. Ricezione e ispezione: dopo che la qualità del prodotto è stata verificata e inserita nel magazzino 51shopy, o dopo aver ricevuto il pacco, se riscontri problemi di qualità con il prodotto o dubiti della sua autenticità, contatta il servizio clienti il ​​prima possibile e fornisci le prove pertinenti.",
    setup342: "2. Materiali di reclamo: fornire il modulo d'ordine, la ricevuta di pagamento, la descrizione del prodotto e la prova di prodotti contraffatti o di qualità inferiore.",
    setup343: "3. Dopo aver ricevuto i materiali del tuo reclamo, il nostro team del servizio clienti comprenderà i dettagli con te e ti aiuterà a comunicare con il venditore per risolvere il problema e si impegnerà a combattere per i tuoi diritti legali.",
    setup344: "Si prega di notare che a causa dell'autenticità del prodotto, potrebbero essere necessarie ulteriori valutazioni professionali e procedure legali. Se è richiesta un'agenzia di valutazione professionale, la commissione di valutazione sarà a vostro carico. Per proteggere i diritti e gli interessi di tutte le parti, vi consigliamo di scegliere canali formali e venditori affidabili al momento dell'acquisto per ridurre il rischio di acquistare prodotti contraffatti.",
    setup345: "Qual è la garanzia di reso/cambio entro 14 giorni?",
    setup346: "La garanzia di reso e cambio di cinque giorni è uno speciale servizio post-vendita (incluso il servizio stesso e il supporto tecnico) fornito dai venditori di piattaforme terze ai consumatori. Entro 14 giorni dalla firma per la merce (ovvero, entro 14 giorni dalla messa in magazzino della merce), gli acquirenti possono restituire o cambiare la merce acquistata in base a questa regola e alle regole pertinenti emesse dalla piattaforma di terze parti.",
    setup347: "Come faccio a determinare se un prodotto è idoneo alla garanzia di reso/cambio?",
    setup348: "I prodotti sono 'idonei' per il servizio di reso e cambio gratuito entro 14 giorni, oppure 'non idonei' per il servizio di reso e cambio gratuito entro 14 giorni",
    setup349: "È disponibile?",
    setup350: "Tipo",
    setup351: "Ad esempio",
    setup352: "Non disponibile",
    setup353: "Determinato in base alle informazioni fornite dal commerciante. Se non possiamo confermare, negozieremo con il venditore in merito al reso/cambio, ma il risultato finale è soggetto alla decisione del venditore.",
    setup354: "Personalizzazione",
    setup355: "Prodotti di design personalizzati",
    setup356: "Non supporta esplicitamente resi e cambi",
    setup357: "Promuovi prodotti difettosi",
    setup358: "Prodotti il ​​cui imballaggio, etichette e accessori sono stati rimossi su richiesta dell'utente",
    setup359: "L'etichetta del vestito è strappata",
    setup360: "Giornali e periodici",
    setup361: "Libri e riviste in abbonamento",
    setup362: "Prodotti di seconda mano",
    setup363: "Prodotti al di fuori della Cina continentale",
    setup364: "Prodotti acquistati dall'estero e da Hong Kong e Macao",
    setup365: "Biancheria intima",
    setup366: "Intimo, calzini, leggings",
    setup367: "Prodotti per adulti",
    setup368: "Altre questioni specificate dal venditore",
    setup369: "Rispettare le regole del venditore",
    setup370: "Cibo",
    setup371: "Biscotti, caramelle, ecc.",
    setup372: "Libri (≥15 libri)",
    setup373: "Non meno di 15 libri",
    setup374: "Articoli che sono stati aperti e che devono soddisfare gli 'standard speciali' per l'imballaggio di reso.",
    setup375: "Per i prodotti di sigillatura, fare riferimento alla tabella allegata",
    setup376: "Disponibile",
    setup377: "Per le richieste di reso/cambio inviate entro 14 giorni dal ricevimento, le elaboreremo secondo le procedure standard.",
    setup378: "Quando il prodotto soddisfa tutti i seguenti requisiti:",
    setup379: "1. Il venditore fornisce una garanzia di reso;",
    setup380: "2. In condizioni di rivendita come richiesto dal venditore;",
    setup381: "3. Il tempo di conservazione non è superiore a 14 giorni.",
    setup382: "Per i prodotti che offrono la spedizione gratuita, sarai responsabile delle spese di spedizione quando restituisci il prodotto. Per i prodotti che non offrono la spedizione gratuita, sarai responsabile delle spese di spedizione quando il venditore invia il prodotto al nostro magazzino e quando restituisci il prodotto al venditore.",
    setup383: "Come richiedere il servizio di reso/cambio",
    setup384: "Entro 14 giorni dal momento in cui lo stato dell'ordine cambia in 'Inventario' (calcolato dall'ora successiva al momento in cui lo stato cambia in 'Inventario', 14 giorni = 336 ore), puoi richiedere il servizio di reso e cambio sulla pagina. Le richieste potrebbero non essere accettate dopo il limite di tempo.",
    setup385: "Precauzioni e FAQ",
    setup386: "Note:",
    setup387: "L'importo totale del rimborso/cambio si basa sul prezzo effettivo del prodotto che hai pagato",
    setup388: "Possiamo restituire/scambiare i prodotti per te solo se il venditore è d'accordo",
    setup389: "Dopo aver richiesto il servizio di reso/cambio, assicurati che ci sia un saldo sufficiente sul tuo account per pagare la spedizione di reso e la commissione di servizio.",
    setup390: "Fare riferimento alla tabella sottostante per i requisiti di imballaggio per la restituzione di alcuni prodotti. Se i requisiti non vengono soddisfatti, non sarà possibile restituire/cambiare il prodotto.",
    setup391: "Standard speciali",
    setup392: "Categoria prodotto",
    setup393: "Standard speciali",
    setup394: "Nuove scarpe sportive",
    setup395: "Le chiusure antifurto (se presenti) e gli adesivi antimanomissione non sono stati tagliati/rimossi e sono perfettamente funzionanti.",
    setup396: "Detersivo / Assorbente / Carta / Profumo",
    setup397: "I contenitori monouso sigillati per prodotti per la cura della persona, se presenti, devono rimanere sigillati.",
    setup398: "Cura dei capelli/Parrucche",
    setup399: "Gli imballaggi monouso sigillati per prodotti per la cura dei capelli (se presenti) devono rimanere sigillati.",
    setup400: "Cura della pelle/Cura del corpo/Oli essenziali",
    setup401: "L'imballaggio monouso sigillato del prodotto (se presente) deve rimanere sigillato",
    setup402: "Cosmetici/Profumi/Strumenti di bellezza",
    setup403: "Prodotti digitali/elettrodomestici (esclusi fotocamere e grandi elettrodomestici)",
    setup404: "1. La licenza di accesso a Internet non è danneggiata (distrutta).",
    setup405: "2. Nessun danno causato dall'acqua.",
    setup406: "Fotocamera digitale/Fotocamera reflex/Fotocamera",
    setup407: "Il pulsante di scatto di una macchina fotografica SLR non deve essere premuto più di 20 volte.",
    setup408: "Grandi elettrodomestici",
    setup409: "1. TV LCD, condizionatore: non ancora installato a parete, è disponibile un semplice debug.",
    setup410: "2. Lavatrice: non è stata ancora utilizzata con acqua.",
    setup411: "Modelli / Periferiche anime / Periferiche anime / Prodotti per giochi di ruolo / Giochi da tavolo",
    setup412: "Il nastro adesivo e i sigilli di plastica (se presenti) su modelli, statuette, modelli di soldati, BJD e altri prodotti non possono essere rimossi.",
    setup413: "Componenti elettronici",
    setup414: "1. La saldatura è vietata.",
    setup415: "2. Il circuito integrato non è mai stato montato su alcuna base IC.",
    setup416: "3. Le confezioni monouso sigillate di materiali di consumo quali grasso termico/pasta termica, colla elettronica/colla per incapsulamento/sigillante/adesivo, colla conduttiva, inchiostro conduttivo, ecc. devono essere tenute sigillate.",
    setup417: "Sottocategoria 'Software di gioco' nella categoria di primo livello 'Videogiochi/Accessori/Giochi/Guide di gioco'",
    setup418: "Cibo per animali domestici, prodotti per la salute e medicinali nella categoria di primo livello 'Animali domestici/Cibo e forniture per animali domestici'",
    setup419: "Libri/Riviste",
    setup420: "1. L'imballaggio monouso sigillato del prodotto (se presente) deve rimanere sigillato",
    setup421: "2. Il prodotto non deve presentare segni lasciati da piegature, macchie d'acqua, sporcizia, inchiostro o lettura.",
    setup422: "Categoria secondaria 'Prodotti per la salute degli animali/Farmaci veterinari' sotto la categoria primaria 'Allevamento di animali/Prodotti agricoli'",
    setup423: "Gli imballaggi monouso sigillati (se presenti) per prodotti quali alimenti (inclusi gli integratori), cosmetici, dispositivi medici, contraccettivi, prodotti per la cura della persona, prodotti per adulti, pannolini per bambini, libri e prodotti audiovisivi devono rimanere sigillati.",
    setup424: "'Sigillatura' si riferisce al sigillo o all'imballaggio in plastica utilizzato dal produttore sulla confezione del prodotto.",
    setup425: "Domande frequenti:",
    setup426: "1. Cosa devo fare se un ordine non coperto dalla 'Garanzia di reso e cambio' presenta problemi post-vendita?",
    setup427: "Quando ci sono problemi di qualità con il prodotto, 51shopy verificherà con il venditore in base alla situazione effettiva, formulerà una soluzione finale e notificherà l'utente. Se non ci sono problemi di qualità con il prodotto, secondo le regole della piattaforma di terze parti, i servizi di reso e cambio non possono essere forniti. 51shopy farà del suo meglio per comunicare con il venditore per proteggere i diritti e gli interessi degli utenti.",
    setup428: "2. Chi è responsabile della spedizione quando si utilizza la 'Garanzia di reso/cambio'? ",
    setup429: "Prima di richiedere il servizio di reso e cambio, il prodotto deve essere nuovo di zecca e soddisfare le condizioni di rivendita. Se il prodotto non presenta problemi di qualità, le spese di spedizione saranno a carico dell'utente. Se il prodotto presenta problemi di qualità, il venditore sosterrà le spese di spedizione dopo che l'utente avrà inviato la richiesta.",
    setup430: "3. Se lo stato dell'ordine è 'non spedito', ci sono costi per il servizio di reso?",
    setup431: "Non preoccuparti, in questo caso non ci sono costi. Ti verrà addebitato un costo solo se la richiesta di reso soddisfa tre condizioni: primo, il prodotto non presenta problemi di qualità. Secondo, il prodotto è già disponibile in magazzino. Terzo, hai esaurito il numero di resi gratuiti di questo mese. Pertanto, non ti addebiteremo nulla se il prodotto non è stato spedito.",
    setup432: "E-mail:",
    setup433: "Tel: +85251387262",
    setup434: "Indirizzo: Stanza 341, 3/F, Edificio industriale pubblico, 56 Hoi Yuen Road, Kwun Tong, Hong Kong",
    setup435: "Powered by 51shopy - Space Network Technology Co., Ltd.",
    setup436: "Aiutarti nell'elaborazione",
    setup437: "I saldi di ieri",
    setup438: "Vendita calda",
    setup439: "Venduto",
    setup440: "Pagamento fallito",
    setup441: "In attesa del pagamento delle spese postali",
    setup442: "Spedizione pagata, in attesa di conferma dalla banca",
    setup443: "Spedizione pagata",
    setup444: "Specifiche",
    setup445: "Pagamento effettivo",
    setup446: "Si consiglia di riflettere attentamente prima di annullare un ordine. La piattaforma non sarà responsabile dell'annullamento di un ordine!",
    setup447: "Cambia",
    setup448: "Paga le spese postali",
    setup449: "Ordine del centro commerciale",
    setup450: "Altro",
    setup451: "portafoglio",
    setup452: "Acquisto",
    setup453: "Rilascio",
    setup454: "Vendi",
    setup455: "Cronologia",
    setup456: "Ordine di acquisto",
    setup457: "Importo da pagare",
    setup458: "Entra nel negozio",
    setup459: "Visualizza altro",
    setup460: "Collapse",
    setup461: "Inserisci",
    setup462: "Il prodotto è esaurito.",
    setup463: "Consigliamo i seguenti prodotti simili",
    setup464: "Prodotti simili",
    setup465: "Esclusione di responsabilità",
    setup467: "L'imballaggio si riferisce all'imballaggio originale del prodotto. Se ispezionato, l'imballaggio logistico verrà rimosso, ad eccezione del prodotto stesso. Per evitare danni al prodotto, verranno conservati i materiali di imballaggio protettivi necessari. Non siamo responsabili se richiedi di rimuovere l'imballaggio.",
    setup468: "Trasporto nazionale completo Per le merci dello stesso venditore, la deviazione del trasporto verrà regolata da noi.",
    setup469: "Per ogni prodotto, scatteremo gratuitamente da 3 a 7 foto per te. Se hai ulteriori esigenze per servizi fotografici squisiti, potremmo addebitare una piccola commissione di servizio.",
    setup470: "I prodotti personalizzati non supportano resi o cambi.",
    setup471: "Per i prodotti approvati per la restituzione e il cambio dal commerciante, puoi richiedere la restituzione e il cambio entro 14 giorni dal momento in cui lo stato dell'ordine cambia in 'In magazzino'. Quando richiedi una restituzione e un cambio, devi sostenere una commissione di gestione di circa 0,75 $ USA e le spese di spedizione nazionali per ogni reso di prodotto diverso, l'importo totale è di circa 3 $ USA.",
    setup472: "Tutti",
    setup473: "Percorso postale",
    setup474: "Spese di spedizione",
    setup475: "Sono richieste le informazioni su lunghezza, larghezza e altezza del pacchetto",
    setup476: "Tempo di trasporto",
    setup477: "giorno",
    setup478: "Esente da tasse",
    setup479: "Può essere assicurato",
    setup480: "Stima spedizione",
    setup481: "Recupera registro password",
    setup482: "Commerciante",
    setup483: "Per favore",
    setup484: "Paga, altrimenti l'ordine verrà annullato",
    setup485: "Prezzo totale della merce",
    setup486: "Totale da pagare",
    setup487: "Paga ora",
    setup488: "Il saldo è insufficiente, ricarica e paga",
    setup489: "Nessun metodo di pagamento adatto? Puoi provare a pagare prima con il tuo saldo",
    setup490: "Già disponibile",
    setup491: "Il trasporto è stato quotato",
    setup492: "Spedizione pagata",
    setup493: "Spedisci esaurito",
    setup494: "Continua a pagare",
    setup495: "N. ordine logistica internazionale",
    setup496: "N. ordine logistica nazionale",
    setup497: "Il tuo browser non supporta il lettore video HTML5.",
    setup498: "Supporta solo il caricamento di immagini in formato PNG e JPEG!",
    setup499: "Completato",
    setup500: "ritorna",
    setup501: "Non hai l'autorizzazione per accedere a questa pagina",
    setup502: "Calcolo del trasporto",
    setup503: "Collaborare con numerose aziende di logistica per offrire gli sconti più favorevoli",
    setup504: "Stima spedizione",
    setup505: "Cerca prodotti",
    setup506: "Visualizza i prodotti in base ai criteri di ricerca",
    setup507: "Informazioni di base",
    setup508: "Inserisci il nome inglese",
    setup509: "Inserisci il nome cinese",
    setup510: "I video caricati possono essere solo in formato MP4, WebM o OGG!",
    setup511: "La dimensione del video caricato non può superare i 2 MB!",
    setup512: "La durata del video non può superare",
    setup513: "secondi",
    setup514: "Impossibile ottenere la durata del video, verificare se il file video è danneggiato",
    setup515: "dati",
    setup516: "",
    setup517: "Inserisci sku",
    setup518: "Inserisci la quantità",
    setup519: "Inserisci il prezzo",
    setup520: "Inserisci i dettagli del prodotto in inglese",
    setup521: "Inserisci i dettagli del prodotto cinese",
    setup522: "Cinese semplificato",
    setup523: "Spagnolo",
    setup524: "Portoghese",
    setup525: "olandese",
    setup526: "Polacco",
    setup527: "Tedesco",
    setup528: "francese",
    setup529: "Italiano",
    setup530: "Abilita specifiche multiple",
    setup531: "Prezzo (CNY)",
    setup532: "Aggiungi Foto Spec",
    setup533: "Agg. Val. Spec",
    setup534: "① Fare doppio clic per modificare, trascinare per regolare l'ordine",
    setup535: "Aggiungi specifiche",
    setup536: "Impostazioni batch",
    setup537: "Si prega di pubblicare sul lato PC",
    setup538: "Nome",
    setup539: "Carica video prodotto",
    setup540: "orario di entrata in magazzino",
    setup541: "orario di uscita in magazzino",
    setup543: "La mia release",
    setup544: "Autenticati come commerciante prima di pubblicare il prodotto",
    setup545: "Vai alla fine del PC per pubblicare il prodotto",
    setup546: "destinazione",
    setup547: "Stati Uniti d'America",
    setup548: "Peso (grammi)",
    setup549: "Categoria prodotto",
    setup550: "Seleziona categoria",
    setup551: "lunghezza",
    setup552: "larghezza",
    setup553: "altezza",
    setup554: "QUERY",
    setup555: "completo",
    setup556: "Può essere assicurato",
    setup557: "duty-free",
    setup558: "spese di spedizione",
    setup559: "Sono necessarie informazioni su lunghezza, larghezza e altezza del pacco",
    setup560: "Tempo di trasporto",
    setup561: "giorni",
    setup562: "Annulla pagamento ustd con successo!",
    setup563: "giornoPromemoria: seleziona il paese di destinazione e il sistema cercherà i percorsi disponibili in quella località",
    setup564: "Restrizioni del pacco",
    setup565: "Limite di peso minimo:",
    setup566: "Limite di peso massimo:",
    setup567: "Regole di fatturazione del peso del volume:",
    setup568: "Limite di dimensione:",
    setup569: "Impossibile inviare",
    setup570: "Può inviare",
    setup571: "Standard di tariffa:",
    setup572: "unità di peso",
    setup573: "prezzo unitario",
    setup574: "Tariffa doganale",
    setup575: "Costo del carburante",
    setup576: "Tariffa di operazione",
    setup577: "Il limite di credito di questa banca è insufficiente, quindi non puoi selezionare questa banca!",
    setup578: "Il saldo di 51coin non è sufficiente, ricarica!",
    setup579: "osservazione",
    setup580: "Seleziona il prodotto che vuoi eliminare!",
    setup581: "Accedi con Google",
    setup582: "La prima immagine è quella principale di default. Trascina per modificare.",
    setup583: "Limite massimo di caricamento raggiunto",
    setup584: "Accedi usando Telegram",
    setup585: "Visualizza logistica",
    setup586: "Informazioni logistiche",
    setup587: "Modifica numero ordine logistico",
    setup588: "Email vincolante",
    setup589: "Per favore leghi prima la sua email",
    setup590: "Puoi inserire fino a 2 tipi di specifiche!",
    setup591: "Modelli comuni",
    setup592: "Seleziona modello",
    setup593: "Annulla",
    setup594: "Aggiungi",
    setup595: "Selezionare il valore della specifica",
    setup596: "Non aggiungere ripetutamente",
    setup597: "Impostazione dei modelli comuni riuscita!",
    setup598: "SKU non può essere vuoto",
    setup599: "Il prezzo non può essere vuoto",
    setup600: "La quantità non può essere vuota",
    setup601: "Impossibile aggiungere lo stesso valore di specifica!",
    setup602: "① Fare doppio clic per modificare",
    setup603: "Si prega di compilare le informazioni specifiche!",
    setup604: "Si prega di compilare i dettagli del prodotto sia in cinese semplificato che in inglese!",
    setup605: "Modifica riuscita",
    setup606: "Aggiungi valore specifica correttamente!",
    setup607: "Imposta come comune",
    setup608: "Inserisci almeno un valore di specifica!",
    setup609: "Inserisci cinese semplificato",
    setup610: "Inserisci l'inglese",
    setup611: "Inserisci spagnolo",
    setup612: "Inserisci portoghese",
    setup613: "Inserisci olandese",
    setup614: "Inserisci polacco",
    setup615: "Inserisci il tedesco",
    setup616: "Inserisci il francese",
    setup617: "Inserisci l'italiano",
    setup618: "Traduzione automatica",
    setup619: "Traduzione",
    setup620: "Tutti gli altri",
    setup621: "INFORMAZIONI SULLA SPEDIZIONE",
    setup622: "Il nostro obiettivo è offrirti le migliori opzioni di spedizione, indipendentemente da dove vivi. Ogni giorno consegniamo a centinaia di clienti in tutto il mondo e ci impegniamo a fornirti servizi di altissimo livello.",
    setup623: "A.Il lasso di tempo di consegna di un ordine è diviso in due parti:",
    setup624: "· Tempo di elaborazione: 3-7 giorni",
    setup625: "· Tempo di spedizione: 14~30 giorni",
    setup626: "B.Metodi di spedizione",
    setup627: "C.Costo di spedizione",
    setup628: "Diritti di proprietà intellettuale",
    setup629: "Trasporto terra/mare",
    setup630: "In attesa di ricezione",
    setup631: "alleanza",
    setup632: "Condividi il tuo codice di affiliazione",
    setup633: "Gli amici che hai invitato confermano di aver ricevuto il tuo codice alleanza",
    setup634: "Ricevi la tua commissione di affiliazione",
    setup635: "Copia questo URL e usalo per reindirizzare gli utenti alla homepage del tuo ID affiliato",
    setup636: "Copia URL",
    setup637: "La mia alleanza",
    setup638: "Registra",
    setup639: "Ottieni",
    setup640: "Domande frequenti sul capitale proprio",
    setup641: "Cos'è il programma di affiliazione?",
    setup642: "51Shopy è un progetto di condivisione e guadagno avviato da tutti gli utenti. Che tu sia un privato o un venditore, unisciti a un promotore di 51Shopy, invita nuovi utenti a registrarsi su 51Shopy e ad acquistare con successo. Diventerà il tuo utente esclusivo e ogni suo acquisto logistico internazionale ti porterà sconti in denaro, fino a un milione di yuan, senza limiti massimi.",
    setup643: "Come viene calcolato il mio bonus?",
    setup644: "Una volta che diventi membro, il tuo account avrà immediatamente un tasso di sconto. Più utenti del settore della logistica internazionale inviti a registrarsi, più bonus riceverai e maggiore sarà il tasso di sconto. Quando il bonus raggiunge un certo importo, puoi richiedere un prelievo in contanti o utilizzarlo per compensare eventuali commissioni di servizio della piattaforma 51Shopy. Il tasso di sconto è di",
    setup645: "Come promuovere gratuitamente?",
    setup646: "Copia il tuo link promozionale e invialo ai tuoi amici cliccando su Condividi nella pagina del prodotto. Quando visiteranno e si registreranno, diventeranno il tuo utente unico.",
    setup647: 'Ora di registrazione',
    setup648: 'Costi di trasporto',
    setup649: 'Stato di attivazione',
    setup650: 'Record bonus',
    setup651: 'Tempo di applicazione',
    setup652: 'Ricompensa totale',
    setup653: 'Invita utenti',
    setup654: 'Vai al portafoglio',
    setup655: "Carta di credito",
    setup656: "Invita gli amici a godere della commissione",
    setup657:"Membro affiliato",
    setup658: "Ordine di acquisto",
    setup659: "La piattaforma di agenti 51Shopy ti offre assistenza nell'acquisto di prodotti online e offline in Cina. Basta fornire il link del prodotto ed effettuare l'ordine: il nostro team fornirà un servizio di prima classe dall'inizio alla fine",
    setup660: "Spedisci al magazzino",
    setup661:"Con noi puoi acquistare prodotti da vari venditori e farteli spedire al magazzino di 51Shopy in Cina",
    setup662: "Controllo qualità",
    setup663: "Una volta che i tuoi articoli arriveranno al magazzino di 51Shopy, effettueremo un'accurata ispezione di qualità, che coprirà tutto, dai difetti alle dimensioni e al colore. Puoi stare certo che 51Shopy offre un servizio post-vendita affidabile e garantito.",
    setup664:"Consegna globale",
    setup665:"Nel magazzino 51Shopy puoi scegliere e combinare liberamente i prodotti e utilizzare l'affidabile servizio logistico fornito da 51Shopy per imballarli e consegnarli a casa tua.",
    setup666: "Servizio completo, senza pensieri durante tutto il processo",
    setup667:"Una volta che gli utenti da te invitati si registreranno, riceveranno USD:",
    setup668: "Spedizione gratuita",
    setup669: "Spese di spedizione escluse",
    setup670: "La spedizione internazionale non è inclusa",
    setup671:"Azienda di logistica",
    setup672: "Seleziona un'azienda di logistica",
    setup673: "Ultimo numero del mittente",
    setup674: "Ultime quattro cifre",
    setup675: "Numero del mittente",
    setup676:"Inserisci",
    setup677: "In attesa di archiviazione",
setup678: "Sono incluse le spese di spedizione internazionali?",
setup679: "Sì",
setup680: "No",
setup681: "Fai clic sul pulsante 'Aggiungi alla schermata iniziale'",
}
//意大利